import { render, staticRenderFns } from "./OrganismModalSuccessFail.vue?vue&type=template&id=b0872ba8&scoped=true"
import script from "./OrganismModalSuccessFail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismModalSuccessFail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0872ba8",
  null
  
)

export default component.exports